/** @format */

import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import AdditonalChargesService from "../../Services/AdditionalChargesService";
import SimpleReactValidator from "simple-react-validator";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";

const CourierRates = () => {
  const [, setForceUpdate] = useState("");
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );
  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  const [loader, setLoader] = useState(true);
  const [fedexList, setFedexList] = useState();
  const [ups, setUps] = useState();

  const history = useHistory();

  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = () => {
    AdditonalChargesService.getCourierrates().then((res) => {
      if (res.status) {
        setLoader(false);
        setFedexList(res.data);
      } else {
        setLoader(false);
      }
    });
  };

  const onchangeArray = (event, key, path) => {
    let { value } = event.target;

    let newArry = [...fedexList];

    let checkNest = path.split(".");

    switch (checkNest.length) {
      case 1:
        newArry[key][checkNest[0]] = value;
        break;
      case 2:
        newArry[key][checkNest[0]][checkNest[1]] = value;
        break;
      case 3:
        newArry[key][checkNest[0]][checkNest[1]][checkNest[2]] = value;
        break;
      default:
    }
    setFedexList(newArry);
  };
  const submitHandler = (key, listdata) => {
    var check_value = [];
    if (key == "Fedex") {
      check_value = [
        "vendor_type",
        "fuel_charges",
        "govt_tax",
        "peak_search_charge_express_freight_shipment",
        "peak_search_charge_express_freight_shipment_min",
        "peak_search_charge_express_shipment",
        "peak_search_charge_express_shipment_min",
      ];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax") &&
        validator.current.fieldValid(key + " express shipment") &&
        validator.current.fieldValid(key + " express shipment min") &&
        validator.current.fieldValid(key + " freight shipment") &&
        validator.current.fieldValid(key + " freight shipment min");
    } else if (key == "Ups") {
      check_value = ["vendor_type", "fuel_charges", "govt_tax"];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax");
    } else if (key == "Tnt") {
      check_value = [
        "vendor_type",
        "fuel_charges",
        "peak_search_charge_express_shipment",
        "haldling_in_out",
        "pallet_charges",
      ];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " express shipment") &&
        validator.current.fieldValid(key + " handling in/out") &&
        validator.current.fieldValid(key + " pallet charges");
    }
    // var postData = { id: listdata["_id"] };
    var postData = {};
    // check_value.forEach(function (e) {
    // postData[e] = listdata[e];
    postData = listdata;
    // });

    // if (validate) {
    AdditonalChargesService.updateCourierrates(postData).then((res) => {
      if (res.status) {
        history.push("/courier-rates");
        getItemList();
        toast.success("Additional charges updated successfully");
      } else {
        toast.error(res.message);
      }
    });
    // } else {
    //   validator.current.showMessages();
    // }
  };
  return (
    <>
      <div className="row">
        {fedexList &&
          fedexList.map((item, key) => {
            return (
              <div className="col-lg-4">
                <div className="card">
                  <div class="d-flex mb-3 align-items-center card-header">
                    <h5 class="mb-0 me-auto">{item.service_provider} </h5>
                  </div>
                  <div className="card-body">
                    <h5>
                      {item.vendor_type === "Tnt" && "Land Consolidation"}
                    </h5>
                    <hr
                      className="mt-1 mb-4"
                      style={{
                        display: item.vendor_type === "Tnt" ? "block" : "none",
                      }}
                    />
                    <>
                      <div className="row">
                        <div className="col-6">
                          <label>Vendor Type</label>
                        </div>
                        <div className="col-6">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Fuel Charges"
                            value={item.service_provider}
                            readOnly
                          />
                        </div>
                      </div>
                    </>

                    <>
                      <div className="row mt-3">
                        <div className="col-6">
                          <label>Transit Time (Days)</label>
                        </div>
                        <div className="col-6">
                          <input
                            // type="number"
                            className="form-control"
                            placeholder="Enter Transit"
                            value={item.transit_time}
                            name="transact_time"
                            onChange={(e) =>
                              onchangeArray(e, key, `${"transit_time"}`)
                            }
                          />
                          {/* {validator.current.message(
                            item.vendor_type + " Govt. tax",
                            item.transact_time,
                            "required",
                            { className: "text-danger text-capitalize" }
                          )} */}
                        </div>
                      </div>
                    </>

                    {item.service_provider === "ups" && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Max weight (Kgs) additional freight (zone price * weight)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.ups_zone_max_kgs}
                              name="ups_zone_max_kgs"
                              onChange={(e) =>
                                onchangeArray(e, key, "json.ups_zone_max_kgs")
                              }
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {item.service_provider !== "dhl" && ( 
                    <>
                      <div className="row mt-3">
                        <div className="col-6">
                          <label>Govt tax: On freight and fuel only for shipments with chargeable wt(Kgs) </label>
                        </div>
                        <div className="col-6">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter min weight"
                            value={item?.json?.min_weight}
                            name="min_weight"
                            onChange={(e) =>
                              onchangeArray(e, key, "json.min_weight")
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </div>
                    </>
                     )}

                    
                     {item.service_provider === "ups" && (
                      <div>
                    <>
                     <div className="row mt-3">
                          <div className="col-12">
                            <h6 style={{ borderTop: '1px solid #b1b0b0' , padding: '12px 0px', fontWeight:700
                              }}>Notes:
                            </h6>
                          </div>
                          <div className="col-6">
                            <label>
                              If L + 2 (W + H) is more than (cms) than shipment not accepted
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Max Dimension"
                              value={item?.json?.max_dimension}
                              name="max_dimension"
                              onChange={(e) =>
                                onchangeArray(e, key, "json.max_dimension")
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                      </div>
                    </>
                      </div>
                     )}


                     {item.service_provider === "ups" && (
                      <div>
                       <h6 style={{padding: '13px 0px 6px 0px',borderTop:"1px solid #b1b0b0", fontWeight:700 , marginTop:'5px'
                      }}>Additional Surcharge</h6>
                      <>
                        <div style={{ border: '1px solid #bbbbbb',padding: '12px 10px',}}>

                        <div className="row mt-3">
                            <div className="col-6">
                              <label>Weight of any package is more than (Kgs)</label>
                            </div>
                            <div className="col-6">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Charges"
                                value={item?.json?.additional_handling_weight}
                                name="additional_handling_weight"
                                onChange={(e) =>
                                  onchangeArray(
                                    e,
                                    key,
                                    "json.additional_handling_weight"
                                  )
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-6">
                              <label>Additional AED (Per pkg)</label>
                            </div>
                            <div className="col-6">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Enter Charges"
                                value={item.json.additional_handling_charge}
                                name="additional_handling_charge"
                                onChange={(e) =>
                                  onchangeArray(
                                    e,
                                    key,
                                    `${"json.additional_handling_charge"}`
                                  )
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            </div>
                          </div>
                        </div>

                    <div style={{ border: '1px solid #bbbbbb', padding: '12px 10px', marginTop:10 }}>
                    <div className="row mt-3">
                        <div className="col-6">
                          <label>Each package if L + 2 (W + H) is greater than (cms)</label>
                        </div>
                        <div className="col-6">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Charges"
                            value={item?.json?.large_package_surcharge}
                            name="large_package_surcharge"
                            onChange={(e) =>
                              onchangeArray(
                                e,
                                key,
                                "json.large_package_surcharge"
                              )
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </div>
                
                      <div className="row mt-3">
                        <div className="col-6">
                          <label>Large Package Surcharge of AED</label>
                        </div>
                        <div className="col-6">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Charges"
                            value={item?.json?.large_package_surcharge_amount}
                            name="large_package_surcharge_amount"
                            onChange={(e) =>
                              onchangeArray(
                                e,
                                key,
                                "json.large_package_surcharge_amount"
                              )
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </div>
                    </div>
        
                    <div style={{ border: '1px solid #bbbbbb', padding: '12px 10px', marginTop:10 }}>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>If length is more than (cms)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.over_max_surcharge_length}
                              name="over_max_surcharge_length"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.over_max_surcharge_length"
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>

                          <p style={{fontWeight:'bold' , textAlign:'center'}}>
                            OR
                          </p>

                        <div className="row mt-3">
                          <div className="col-6">
                            <label>If any package is more than (Kgs)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.max_weight}
                              name="max_weight"
                              onChange={(e) =>
                                onchangeArray(e, key, "json.max_weight")
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>

                        <hr style={{background:"black" , height:1}} />
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Over Max Surcharge of AED</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item?.json?.over_max_surcharge}
                              name="over_max_surcharge"
                              onChange={(e) =>
                                onchangeArray(e, key, "json.over_max_surcharge")
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                      </div>

                    </>
                      </div>
                    )}

                    {item.service_provider === "dhl" && (
                    <div>
                    <h6 style={{
                    borderTop: '1px solid #b1b0b0',
                    padding: '13px 0px 6px',
                    marginTop:'20px',
                    fontWeight:700
                    }}>Over weight Surcharges</h6>
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Is charged for every pkg that is more than (Kgs)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.per_package_weight}
                              name="per_package_weight"
                              onChange={(e) =>
                                onchangeArray(e, key, "json.per_package_weight")
                              }
                            />
                          </div>
                        </div>
                      </>

                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>A fee of AED</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.overweight_surcharge_amount}
                              name="overweight_surcharge_amount"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.overweight_surcharge_amount"
                                )
                              }
                            />
                          </div>
                        </div>
                      </>
                    </div>
                    )}


                    {item.service_provider === "fedex" && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Max weight (Kgs) additional freight (zone price * weight)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.fedex_zone_max_kgs}
                              name="fedex_zone_max_kgs"
                              onChange={(e) =>
                                onchangeArray(e, key, "json.fedex_zone_max_kgs")
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {item.service_provider === "fedex" && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Check Express Weight</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.check_express_weight}
                              name="check_express_weight"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.check_express_weight"
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {/* ------------- Express Shipment ----------- */}
                    {item.service_provider === "fedex" && (
                            <h6 style={{
                              borderTop: '1px solid #b1b0b0',
                              padding: '13px 0px 6px',
                              fontWeight:700,
                              marginTop:"20px"
                              }}>Express Shipment</h6>
                      // <h5 className="mt-4">Express Shipment</h5>
                    )}

                    { item.service_provider == "dhl" && (
                    <div>
                    <h6 style={{
                    borderTop: '1px solid #b1b0b0',
                    padding: '13px 0px 6px',
                    marginTop:"20px",
                    fontWeight:700
                    }}>Over size Surcharge</h6>
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                            Is applied for all pkgs which have anyone of their side more than
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Max Dimension"
                              value={item?.json?.max_dimension}
                              name="max_dimension"
                              onChange={(e) =>
                                onchangeArray(e, key, "json.max_dimension")
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                      </>

                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>A fee of AED</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item?.json?.additional_surcharge_charge}
                              name="additional_surcharge_charge"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.additional_surcharge_charge"
                                )
                              }
                            />
                          </div>
                        </div>
                      </>
                    </div>
                    )}

                    {item.service_provider === "fedex" && (
                    <div style={{ border: '1px solid #bbbbbb', padding: '12px 10px', marginTop:10 }}>
                    <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Any side is more than (cms)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.express_shipment.max_size}
                              name="max_size"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  `json.express_shipment.max_size`
                                )
                              }
                            />
                          </div>
                        </div>
            
                        <p style={{fontWeight:'bold' , textAlign:'center'}}>
                            OR
                          </p>

                        <div className="row mt-3">
                          <div className="col-6">
                            <label>The Second Longest Side is More Than (cms)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.json.express_shipment.second_longest_side
                              }
                              name="second_longest_side"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_shipment.second_longest_side"
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>

                        <p style={{fontWeight:'bold' , textAlign:'center'}}>
                            OR
                          </p>

                        <div className="row mt-3">
                          <div className="col-6">
                            <label>If L + 2 (W + H) is greater than (cms)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.express_shipment.max_dimension}
                              name="max_dimension"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_shipment.max_dimension"
                                )
                              }
                            />
                          </div>
                        </div>

                        <hr style={{background:"black" , height:1}} />

                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Additional Surcharge AED</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.json.express_shipment
                                  .additional_surcharge_amount
                              }
                              name="additional_surcharge_amount"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_shipment.additional_surcharge_amount"
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                    </>
                    </div>
                    )}

                    {item.service_provider === "fedex" && (
                    <div style={{ border: '1px solid #bbbbbb', padding: '12px 10px', marginTop:10 }}>
                      <>
                      <div className="row mt-3">
                          <div className="col-6">
                            <label>If weight of any package is more than (Kgs)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.express_shipment.per_pack_weight}
                              name="per_pack_weight"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_shipment.per_pack_weight"
                                )
                              }
                            />
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Additional AED</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.additional_shipment_amount}
                              name="additional_shipment_amount"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.additional_shipment_amount"
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                      </>
                    </div>
                    )}

                  {/* ---------------  Express Frieght Shipment -------------------- */}
                  
                    {item.service_provider === "fedex" && (
                      <>
                          <h6 style={{
                    borderTop: '1px solid #b1b0b0',
                    padding: '13px 0px 6px',
                    fontWeight:700,
                    marginTop:"20px"
                    }}>Express Freight Shipment</h6>

                        <div style={{ border: '1px solid #bbbbbb', padding: '12px 10px', marginTop:10 }}>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>If L + 2 (W + H) is more than (cms)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.express_shipment.max_dimension}
                              name="max_dimension"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_shipment.max_dimension"
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                      
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Large Package Surcharge of AED</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.json.express_frieght_shipment
                                  .large_package_surcharge_amount
                              }
                              name="large_package_surcharge_amount"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_frieght_shipment.large_package_surcharge_amount"
                                )
                              }
                            />
                          </div>
                        </div>
                        </div>
                      </>
                    )}



                    {item.service_provider === "fedex" && (
                      <>
                      <div style={{ border: '1px solid #bbbbbb', padding: '12px 10px', marginTop:10 }}>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>If any of the longest side is above (cms)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.json.express_frieght_shipment.longest_side
                              }
                              name="longest_side"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_frieght_shipment.longest_side"
                                )
                              }
                            />
                          </div>
                        </div>

                        <p style={{fontWeight:'bold' , textAlign:'center'}}>
                            OR
                          </p>

                        <div className="row mt-3">
                          <div className="col-6">
                            <label>If L + 2 (W + H) is more than (cms)</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={item.json.express_frieght_shipment.max_dimension}
                              name="max_dimension"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_frieght_shipment.max_dimension"
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </div>
                        </div>
                        <hr style={{background:"black" , height:1}} />


                        <div className="row mt-3">
                          <div className="col-6">
                            <label>Over max surcharge of AED</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.json.express_frieght_shipment
                                  .over_max_surcharge_amount
                              }
                              name="over_max_surcharge_amount"
                              onChange={(e) =>
                                onchangeArray(
                                  e,
                                  key,
                                  "json.express_frieght_shipment.over_max_surcharge_amount"
                                )
                              }
                            />
                          </div>
                        </div>
                        </div>
                      </>
                    )}

                   
                    {
                       (CheckAccess(216,"edit") || user_type === "SUPERADMIN") && 
                    <button
                      class="btn btn-primary ms-auto d-block mt-3"
                      onClick={() => submitHandler(item.vendor_type, item)}
                    >
                      Update{" "}
                    </button>
                    }

                  </div>
                </div>
              </div>
            );
          })}
        <Loader isShow={loader} />
      </div>
    </>
  );
};

export default CourierRates;
